export const hostingUrls = {
  mainUrl: process.env.REACT_APP_HOSTING_URL_PRIMARY,
  subUrl: process.env.REACT_APP_HOSTING_URL_SECONDARY,
};
